import {
  OrdersClient,
  ProductDetailDrawerRequestDto,
} from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/index";
import ms from "ms";
import { OrdersQueryKeys } from "@features/orders-features/hooks/OrdersQueryKeys";


export function useGetOrderProductDetailDrawerImages(
  request: ProductDetailDrawerRequestDto | null,
  fallbackImages: boolean,
) {
  const ordersApi = useApi(OrdersClient);

  return useQuery({
    queryKey: [
      OrdersQueryKeys.OrderProductDetailsDrawerImages,
      {
        productDescriptor: request?.productDescriptor,
        productClass: request?.productClass,
        cNetProductId: request?.cNetProductId,
      },
    ],
    queryFn: async () => {
      if (!request) {
        throw new Error("ProductDetailDrawerRequest is required");
      }
      return await ordersApi.getOrderProductDetailDrawerImages(request);
    },
    enabled: fallbackImages && !!request,
    staleTime: ms("1m"),
    retry: false,
  });
}
